module.exports = __webpack_public_path__ + "img/logo._antiguo.cba21f0d.png";